import {clearAll, httpMonitorSelectedIdsSelector} from 'features/http/model/httpMonitorSlice';
import {useMonitorSelection, IUseMonitorSelection} from 'entities/monitor';

export const useHttpMonitorSelection = (): IUseMonitorSelection =>
    useMonitorSelection(httpMonitorSelectedIdsSelector, clearAll);

export default useHttpMonitorSelection;
